<template>
  <div class="home">
    <h1 class="title">Welcome aboard!</h1>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  components: {
  }
}
</script>

<style scoped>

h1.title {
  font-family: 'Orbitron', sans-serif;
  font-weight: 900;
  margin-right: auto;
  color: ivory;
}

h4 {
  font-family: 'Gamja Flower', cursive;
  font-size: 24px;
}

</style>
